/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * EUCデータ種類
 */
export type EucDataType = (typeof EucDataType)[keyof typeof EucDataType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EucDataType = {
  'expenditure-record': 'expenditure-record',
  'revenue-record': 'revenue-record',
  'revenue-appropriation-record': 'revenue-appropriation-record',
} as const;
